module.exports = __webpack_public_path__ + "static/ogimage-965146150aaa80e715ee3a6518971a11.jpg";